import Modal from "../../../../../components/Modal/Modal";
import Button from "../../../../../components/Button/Button";
import { getFileTypeIcon } from "../../../../../utils/functions/file-icon-extractor";
import RefreshPageIcon from "../../../../../assets/svg/refresh-page-icon";
import ClipLoader from "../../../../../components/Common/ClipLoader";

interface ExportQueuedModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  entityName: string;
  fileName: string;
  onViewImportsExports?: () => void;
}

const ExportQueuedModal = ({
  open,
  onOpenChange,
  entityName,
  fileName,
  onViewImportsExports,
}: ExportQueuedModalProps) => {
  const customHeader = (
    <div className="flex items-center justify-between w-full">
      <div className="flex items-center gap-3">
        <RefreshPageIcon className="w-6 h-6 text-verba-blue dark:text-verba-blue-dk" />
        <h1 className="text-base font-medium text-verba-indigo dark:text-verba-indigo-dk">
          Export added to Queue
        </h1>
      </div>
      {/* <button
        className="w-[15px] h-[15px] bg-gray-100 dark:bg-tag-gray-dk rounded-full flex flex-col items-center justify-center transition-transform duration-200 hover:scale-110"
        onClick={() => onOpenChange(false)}
      >
        <CloseIcon className="w-[5.5px] h-[5.5px] text-verba-indigo dark:text-verba-indigo-dk" />
      </button> */}
    </div>
  );

  return (
    <Modal
      open={open}
      onOpenChange={onOpenChange}
      title=""
      showHeader
      showCloseButton={false}
      customHeader={customHeader}
      headerClassName="px-6 pt-6 pb-0"
      bodyClassName="!p-0 flex flex-col"
      contentClassName="w-[410px] max-w-[410px] bg-pure-white dark:bg-pure-white-dk rounded-[16px]"
      disableDefaultAnimation
      contentStyle={{
        left: "50%",
        top: "50%",
        transform: "translate(-50%, -50%)",
      }}
    >
      <div className="flex flex-col px-6 pt-5 pb-6 gap-5">
        <div className="flex items-center gap-2 p-2 border border-border-gray dark:border-border-gray-dk rounded-lg bg-hover-effect dark:bg-hover-effect-dk">
          <img
            src={getFileTypeIcon(fileName)}
            alt={fileName}
            className="w-6 h-6 shrink-0"
          />
          <div className="flex flex-col min-w-0">
            <p className="text-md font-medium text-heading-text dark:text-heading-text-dk truncate">
              {fileName}
            </p>

            <span className="text-xxs text-analytics-gray dark:text-analytics-gray-dk">
              Added to Queue
            </span>
          </div>
        </div>
        <p className="text-md text-verba-indigo dark:text-verba-indigo-dk">
          We&apos;re generating{" "}
          <span className="font-medium">{entityName}</span> now. Your export has
          been added to the queue. You&apos;ll find it in{" "}
          <button
            type="button"
            onClick={onViewImportsExports}
            className="font-medium text-verba-blue dark:text-verba-blue-dk underline"
          >
            Imports / Exports in Settings.
          </button>
        </p>
      </div>

      <div className="flex items-center justify-end gap-3 px-6 py-4">
        <Button
          type="button"
          innerText="Go to Imports / Exports"
          onClick={onViewImportsExports}
          disabled={!onViewImportsExports}
          buttonContainerClass="px-[24px] py-1.5 border border-border-gray dark:border-border-gray-dk hover:bg-hover-effect dark:hover:bg-hover-effect-dk rounded-[6px]"
          innerTextClass="text-md font-semibold text-verba-indigo dark:text-verba-indigo-dk"
        />
        <Button
          type="button"
          innerText="Okay, Noted"
          onClick={() => onOpenChange(false)}
          buttonContainerClass="px-[24px] py-1.5 bg-verba-indigo dark:bg-verba-indigo-dk hover:bg-verba-blue-hover dark:hover:bg-verba-blue-hover-dk rounded-[6px]"
          innerTextClass="text-md font-medium text-pure-white dark:text-pure-white-dk"
        />
      </div>
    </Modal>
  );
};

export default ExportQueuedModal;
